<template>
  <div class="week-count">
    <!-- <div class="count-wrapper"> -->
      <mt-cell v-for="(item,index) in weekDatas" :key="index"
        :title="item.week"
        :to="'/DayCardDetail/'+ item.id"
        is-link>
        <span>{{item.date}}</span>
        <span v-show="item.late > 0">(迟到)</span>
        <span v-show="item.lack > 0">(缺卡)</span>
        <span v-show="item.early > 0">(早退)</span>
      </mt-cell>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: [
    'weekDatas'
  ],
  created() {
  }
}
</script>

<style lang="scss">
  .week-count{
    border-bottom: 10px solid #f2f2f2;
    &:last-child{
      border-bottom: none;      
    }
    .mint-cell-value.is-link {
      margin-right: 12px;
    }
    .mint-cell{
      &:last-child{
        background-size: 100% 0;
        .mint-cell-wrapper {
          background-size: 100% 0px;
        }
      }
    }
    .mint-cell-wrapper {
      background-size: 100% 1px;
      background-position: bottom left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/weekCount.vue